import { getDLTypeDescription } from "@/stores/services/utils/validationUtils"

export const typeMapping = {
  EMERCONTACT: {
    cartInstructions: 'EMERCONTINCARTTXT',
    completeInstructions: 'EMERCONTACTTRNCMPTXT',
    printProduct: false,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: { name: 'AddEmergencyContact' },
    tableHeaders: ['ID Number', 'Date of Birth', 'Identification Type'],
    editable: true,
    canAddServices: true,
    hasLineItems: false,
  },

  DLSBLTR: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'DOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: '',
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  DLRENEW: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'DLRENEW' } },
    tableHeaders: ['ID Number', 'Date of Birth', 'Years Renewed'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },
  RDLOPTIN: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'RDLOPTIN' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },
  RIDOPTIN: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'RIDOPTIN' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },
  IDRENEW: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLIDRENEWTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'RenewalOptions', params: { serviceType: 'IDRENEW' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  DLDUP: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLDUPTRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'DuplicateOptions', params: { serviceType: 'DLDUP' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  IDDUP: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'IDDUPTRNCMPTXT',
    printProduct: false,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'DuplicateOptions', params: { serviceType: 'IDDUP' } },
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  DLCOA: {
    cartInstructions: 'PHYSICALDOCINCART',
    completeInstructions: 'DLCOATRNCMPTXT',
    printProduct: true,
    physicalProduct: true,
    icon: 'ri-id-card-fill',
    editPage: { name: 'COAChangeAddress' },
    tableHeaders: ['ID Number', 'Date of Birth', 'Update Voter Registration'],
    editable: true,
    canAddServices: true,
    hasLineItems: true,
  },

  VRCOA: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'VRCOATRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: { name: 'COAVerifyIdentity' },
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: true,
    canAddServices: true,
    hasLineItems: false,
  },

  DLRESTOREREQLTR: {
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'DOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: '',
    tableHeaders: ['ID Number', 'Date of Birth'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  DLRESTORFEE: {
    header: "Driver's License Restoration Fee",
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-id-card-fill',
    editPage: '',
    tableHeaders: ["Driver's License Number", 'Date of Birth'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },


  VRRENEW: {

    cartInstructions: 'DOCINCARTTXT',

    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  VRRESTOREREQLTR: {
    header: 'Vehicle Restoration Requirements Letter',
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  VRRESTORFEE: {

    cartInstructions: 'DOCINCARTTXT',

    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  VRLOCALUSE: {

    cartInstructions: 'DOCINCARTTXT',

    completeInstructions: 'VRLOCLUSEFEETRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Amount'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },

  VRINSURANCE: {
    header: 'Proof of Insurance',
    cartInstructions: 'DOCINCARTTXT',
    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-contract-line',
    editPage: { name: 'AddInsuranceInfo' },
    tableHeaders: ['Title Number', 'Plate Number'],
    editable: true,
    canAddServices: true,
    hasLineItems: false,
  },

  VRCIVILPENALTY: {

    cartInstructions: 'DOCINCARTTXT',

    completeInstructions: 'NOPHYSCLDOCTRNCMPTXT',
    printProduct: true,
    physicalProduct: false,
    icon: 'ri-car-fill',
    editPage: '',
    tableHeaders: ['Title Number', 'Amount'],
    editable: false,
    canAddServices: true,
    hasLineItems: false,
  },
}

export const RENEWAL_YEARS_LABEL = {
  '2YRREDCOST': '2',
  '4YRFULLCOST': '4',
}


export const headerValueExtractors = {
  "Driver's License Number": (item) => item.idNumber || '',
  'ID Number': (item) => item.idNumber || '',
  'Date of Birth': (item, fmt) => fmt(item.dob) || '',
  Amount: (item) => `$${(item.totalAmount || 0).toFixed(2)}`,
  'Identification Type': (item) => getDLTypeDescription(item.idType),
  'Update Voter Registration': (item) => (item.motorVoterCoa ? 'Yes' : 'No'),
  Address: (item) => [item.address1, item.poBox, item.city, item.state, item.zip].filter(Boolean).join(', '),
  'Fee ID': (item) => item.idNumber || '',
  'Title Number': (item) => item.titleNumber || '',
  'Plate Number': (item) => item.tagNumber || '',
  'Donor ID': (item) => item.idNumber || '',
  Date: (item, fmt) => fmt(item.dob) || '',
  'Years Renewed': (item, _fmt, tempTransactionDetails) =>
    RENEWAL_YEARS_LABEL[tempTransactionDetails?.renewalYears] || '',
}


export const DONATION_FIELD_MAP = {
  DONATEODTF: 'dlDonateOdtf',
  DONATEPBCC: 'dlDonatePbcc',
  DONATEPCRF: 'dlDonatePcrf',
  DONATEVTF: 'dlDonateVtf',
  DONATECTF: 'dlDonateCtfd',
  DONATEKTF: 'dlDonateKtf',
}

const SERVICE_RENEWAL_LABEL = {
  DLRENEW: "Driver's License Renewal",
  IDRENEW: 'Photo ID Renewal',
  DLDUP: "Driver's License/Camera Card Duplicate",
  IDDUP: 'Photo ID/Camera Card Duplicate',
  RDLOPTIN: "Driver's License REAL ID Opt In",
  RIDOPTIN: 'Photo ID REAL ID Opt In',
}

const REAL_ID_OPT_IN_SERVICES = new Set(['RDLOPTIN', 'RIDOPTIN'])


export const buildRenewalLineItems = (item, tempTransactionDetails = {}, referenceValues = []) => {
  const { feeData, addOrganDonor, addVeteransDesignation } = tempTransactionDetails

  if (item.serviceType === 'DLCOA' || item.serviceType === 'IDCOA') {
    const idLabel = getDLTypeDescription(item.idType) || "Driver's License"
    return [{ title: `${idLabel} Change of Address`, price: 0, category: 'Service Fees' }]
  }
  if (item.serviceType === 'VRCOA') {
    return [{ title: 'Vehicle Registration Change of Address', price: 0, category: 'Service Fees' }]
  }

  if (!feeData) return []

  const donationLabelByApiField = Object.fromEntries(
    referenceValues
      .filter((ref) => DONATION_FIELD_MAP[ref.value])
      .map((ref) => [DONATION_FIELD_MAP[ref.value], ref.altDescription]),
  )

  const items = [
    {
      title: `${SERVICE_RENEWAL_LABEL[item.serviceType]} Fee`,
      price: feeData.baseFee,
      category: 'Service Fees',
    },
  ]


  if (REAL_ID_OPT_IN_SERVICES.has(item.serviceType) && feeData.realIdOptinFee > 0) {
    items.push({
      title: 'REAL ID Opt In One-Time Fee',
      price: feeData.realIdOptinFee,
      category: 'Service Fees',
    })
  }

  if (addOrganDonor) {
    items.push({ title: 'Organ Donor', price: 0, category: 'Designations' })
  }

  if (addVeteransDesignation) {
    items.push({ title: "Veteran's Designation", price: 0, category: 'Designations' })
  }

  for (const [apiField, label] of Object.entries(donationLabelByApiField)) {
    const amount = feeData[apiField]
    if (amount > 0 && item[apiField] === true) {
      items.push({ title: label, price: amount, category: 'Donation(s)' })
    }
  }

  return items
}
